import { useState, useEffect } from "react";
import { http } from "../../auth";
import { FiInstagram } from "react-icons/fi";
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaYoutube, FaTiktok, FaTelegram } from "react-icons/fa";

const socialIconMap = [
  { keys: ["facebook"], icon: <FaFacebook className="color-white" size={25} /> },
  { keys: ["twitter", "x"], icon: <FaTwitter className="color-white" size={25} /> },
  { keys: ["instagram"], icon: <FiInstagram className="color-white" size={25} /> },
  { keys: ["whatsapp"], icon: <FaWhatsapp className="color-white" size={25} /> },
  { keys: ["linkedin"], icon: <FaLinkedin className="color-white" size={25} /> },
  { keys: ["youtube"], icon: <FaYoutube className="color-white" size={25} /> },
  { keys: ["tiktok"], icon: <FaTiktok className="color-white" size={25} /> },
  { keys: ["telegram"], icon: <FaTelegram className="color-white" size={25} /> },
];

const getSocialIcon = (nombre) => {
  const lower = (nombre || "").toLowerCase();
  const match = socialIconMap.find(({ keys }) => keys.some((k) => lower.includes(k)));
  return match ? match.icon : null;
};

const SocialMedia = () => {
  const [dataSocialMedia, setDataSocialMedia] = useState([]);

  const fetchDataRedesSociales = async () => {
    try {
      let response = await http.get(`/config/intranet_config_residencial/enlaces_redes_sociales`);
      const raw = response.data?.enlaces_redes_sociales || response.data || [];
      setDataSocialMedia(Array.isArray(raw) ? raw : []);
    } catch (error) {
      console.error("Error al obtener redes sociales:", error);
    }
  };

  useEffect(() => {
    fetchDataRedesSociales();
  }, []);

  if (dataSocialMedia.length === 0) return null;

  return (
    <div className="redes-sociales d-flex align-items-center me-2">
      {dataSocialMedia.map((item, index) => {
        const enlace = item.enlace || item.link || item.url;
        const nombre = item.nombre || item.name || "";
        const icono = getSocialIcon(nombre);

        if (!enlace) return null;

        return (
          <a
            key={index}
            href={enlace}
            target="_blank"
            rel="noopener noreferrer"
            className="red-social-link"
            title={nombre}
          >
            {icono || (
              <img
                src={item.icono || item.image}
                alt={nombre}
                style={{ width: 25, height: 25, objectFit: "contain" }}
              />
            )}
          </a>
        );
      })}
    </div>
  );
};

export default SocialMedia;
